/* 2026 WilderdijkDynamics. R13, cart presentation only. The native Empire add-to-cart request and events remain unchanged. */
(function () {
  'use strict';
  if (window.WDAtcExperience) return;

  var labels = document.querySelector('[data-wd-atc-labels]');
  if (!labels) return;

  var modal = null;
  var lastFocused = null;
  var busy = false;
  // V4.113: keep upsell cart refreshes scoped to the flyout that created them.
  // An upsell cart.js response may arrive after the customer has already closed
  // that flyout and started a new main-product ATC flow. Never let that stale
  // response dispatch Empire's global ATC event or mutate the new flyout.
  var activeNativeBanner = null;
  var nativeBannerSequence = 0;
  var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/').replace(/\/?$/, '/');
  var cartUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || rootPath + 'cart';

  function label(key, fallback) {
    var value = labels.getAttribute('data-' + key);
    return value && value.trim() ? value : fallback;
  }

  function baseViewCartLabel() {
    var raw = label('view-cart', 'View cart');
    var cleaned = raw
      .replace(/%%COUNT%%/g, '')
      .replace(/\(\s*\)/g, '')
      .replace(/\s{2,}/g, ' ')
      .trim()
      .replace(/[·•,:-]\s*$/, '')
      .trim();
    return cleaned || 'View cart';
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text !== undefined && text !== null) node.textContent = String(text);
    return node;
  }

  function money(cents, currency) {
    if (typeof cents !== 'number' || !Number.isFinite(cents)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency || 'EUR'
      }).format(cents / 100);
    } catch (error) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, labels.getAttribute('data-money-format') || '${{amount}}');
      }
      return String(cents / 100);
    }
  }

  // Product URLs come from FBT Liquid: the link is a product variant, never an automatic cart add.
  function upsells() {
    var root = document.querySelector('.wd-fbt');
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll('[data-item][data-upsell-url]'))
      .filter(function (node) {
        // Never offer a sold-out variant, even if another script leaves a card in the DOM.
        var availability = node.querySelector('.wd-fbt__avail');
        var status = availability && availability.getAttribute('data-status');
        var checkbox = node.querySelector('.wd-fbt__checkbox');
        return !node.classList.contains('is-added') &&
          // Bundled add-ons require separate component stock validation; omit them here.
          node.getAttribute('data-upsell-has-bundle') !== 'true' &&
          (status === 'available' || status === 'backorder') &&
          !!checkbox && !checkbox.disabled;
      })
      .slice(0, 3).map(function (node) {
        var image = node.querySelector('.wd-fbt__thumb img');
        var name = node.querySelector('.wd-fbt__name');
        var price = node.querySelector('.wd-fbt__price-now');
        var checkbox = node.querySelector('.wd-fbt__checkbox');
        var availability = node.querySelector('.wd-fbt__avail');
        var status = availability.getAttribute('data-status');
        var availabilityText = availability.querySelector('.wd-fbt__avail-text');
        var id = Number(node.getAttribute('data-variant-id'));
        return {
          id: Number.isSafeInteger(id) && id > 0 ? id : 0,
          url: node.getAttribute('data-upsell-url'),
          image: image ? image.getAttribute('src') : '',
          name: name ? name.textContent.trim() : '',
          price: price ? price.textContent.trim() : '',
          status: status,
          availabilityText: availabilityText ? availabilityText.textContent.replace(/\s+/g, ' ').trim() : '',
          // Only Shopify-orderable variants are rendered into FBT; sold-out is excluded.
          canAdd: !!(checkbox && !checkbox.disabled && Number.isSafeInteger(id) && id > 0)
        };
      }).filter(function (item) {
        return item.canAdd && item.url && item.url.charAt(0) === '/' && item.name;
      });
  }

  function updateHeaderCartCount(cart) {
    if (!cart) return;
    document.querySelectorAll('[data-header-cart-count]').forEach(function (counter) {
      counter.dataset.headerCartCount = cart.item_count;
      counter.classList.toggle('visible', cart.item_count > 0);
    });
  }

  function refreshCartUi(cart, context) {
    if (!cart) return;

    // Update the header directly. Do NOT emit Empire's global cartcount:update
    // event for an upsell request. That event is also used to initialise the
    // native ATC flyout. A delayed upsell response could otherwise interfere
    // with the next main-product flyout started immediately after closing.
    updateHeaderCartCount(cart);

    var banner = context && context.banner;
    var session = context && context.session;
    var bannerIsCurrent = !!(
      banner &&
      banner.isConnected &&
      activeNativeBanner === banner &&
      banner.__wdAtcSession === session
    );

    if (bannerIsCurrent) {
      banner.querySelectorAll('[data-atc-banner-cart-subtotal]').forEach(function (subtotal) {
        subtotal.textContent = money(cart.total_price, cart.currency);
      });
      banner.querySelectorAll('[data-atc-banner-cart-button]').forEach(function (count) {
        count.textContent = baseViewCartLabel();
      });
    }

    // Keep support for the optional standalone WD dialog, but only touch it
    // while that exact dialog is still mounted.
    if (modal && modal.isConnected) {
      modal.querySelectorAll('.wd-atc-dialog__subtotal-price').forEach(function (subtotal) {
        subtotal.textContent = money(cart.total_price, cart.currency);
      });
      modal.querySelectorAll('[data-wd-modal-cart-count]').forEach(function (count) {
        count.textContent = baseViewCartLabel();
      });
      var itemCount = modal.querySelector('.wd-atc-dialog__count');
      if (itemCount) itemCount.textContent = String(cart.item_count) + ' ' + label('cart-items', 'items in cart');
    }
  }

  function addSingleUpsell(item, button, card) {
    if (!item.canAdd || button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    var feedback = card.querySelector('[data-wd-upsell-feedback]');
    var sourceBanner = card.closest('[data-atc-banner]');
    var sourceSession = sourceBanner ? sourceBanner.__wdAtcSession : null;
    if (feedback) feedback.textContent = '';
    // One additional item; the main product must never be sent a second time.
    var addedItem = null;
    fetch(rootPath + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: item.id, quantity: 1 }] })
    }).then(function (response) {
      if (!response.ok) throw new Error('Add failed');
      return response.json();
    }).then(function (responseItem) {
      addedItem = responseItem;
      // The write succeeded. Never offer a retry just because reading cart.js failed.
      if (feedback) feedback.textContent = label('added-upsell', 'Added');
      card.classList.add('is-added');
      button.textContent = label('added-upsell', 'Added');
      button.setAttribute('aria-label', label('added-upsell', 'Added'));
      var original = document.querySelector('.wd-fbt [data-item][data-variant-id="' + item.id + '"]');
      if (original) original.classList.add('is-added');
      return fetch(rootPath + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart unavailable');
          return response.json();
        }).then(function (cart) {
          refreshCartUi(cart, { banner: sourceBanner, session: sourceSession });
          // Safe compatibility signal for other theme components/integrations.
          // Do not emit cartcount:update or addToCartFlyout:complete here: those
          // belong to Empire's primary ATC lifecycle and previously caused the
          // second-click popup race. This event only reports the completed cart.
          document.dispatchEvent(new CustomEvent('wd:cart:updated', {
            detail: { cart: cart, item: addedItem, source: 'atc_upsell' }
          }));
        }).catch(function () {
          // Cart can be re-read on the cart page; do not send another add request.
        });
    }).catch(function () {
      if (feedback) feedback.textContent = label('add-error', 'Add failed');
      button.disabled = false;
    }).finally(function () {
      button.removeAttribute('aria-busy');
    });
  }

  function recommendations(options) {
    var items = upsells();
    if (!items.length) return null;
    var allowQuickAdd = !!(options && options.allowQuickAdd);
    var wrapper = el('div', 'wd-atc-recs');
    wrapper.appendChild(el('h3', 'wd-atc-recs__heading', label('upsells', 'Complete your setup')));
    var list = el('div', 'wd-atc-recs__list');
    items.forEach(function (item) {
      var card = el('div', 'wd-atc-recs__item');
      if (item.image) {
        var image = el('img', 'wd-atc-recs__image');
        image.src = item.image;
        image.alt = '';
        image.width = 76;
        image.height = 76;
        image.loading = 'lazy';
        card.appendChild(image);
      }
      var meta = el('div', 'wd-atc-recs__meta');
      meta.appendChild(el('span', 'wd-atc-recs__name', item.name));
      if (item.price) meta.appendChild(el('span', 'wd-atc-recs__price', item.price));
      // Show a compact per-variant stock/delivery line before the product detail link.
      if (item.availabilityText) {
        var stock = el('span', 'wd-atc-recs__availability wd-atc-recs__availability--' + item.status);
        stock.appendChild(el('span', 'wd-atc-recs__availability-dot'));
        stock.appendChild(el('span', '', item.availabilityText));
        meta.appendChild(stock);
      }
      var link = el('a', 'wd-atc-recs__view', label('view', 'View details'));
      link.href = item.url;
      meta.appendChild(link);
      var feedback = el('span', 'wd-atc-recs__feedback');
      feedback.setAttribute('aria-live', 'polite');
      feedback.setAttribute('data-wd-upsell-feedback', '');
      meta.appendChild(feedback);
      card.appendChild(meta);
      if (allowQuickAdd && item.canAdd) {
        var add = el('button', 'wd-atc-recs__add', label('quick-add', 'Add to cart'));
        add.type = 'button';
        add.setAttribute('aria-label', label('quick-add', 'Add to Cart') + ': ' + item.name);
        add.addEventListener('click', function () { addSingleUpsell(item, add, card); });
        card.appendChild(add);
      }
      list.appendChild(card);
    });
    wrapper.appendChild(list);
    return wrapper;
  }

  // Native Empire adds and updates its own banner and fires cartcount:update once per success.
  // Decorate its DOM only, and do not add another /cart/add.js call or custom cart event.
  function enhanceNativeBanner() {
    var header = document.querySelector('[data-site-header]');
    var banner = header && header.querySelector('[data-atc-banner]');
    if (!banner || banner.hasAttribute('data-wd-atc-enhanced')) return;
    banner.setAttribute('data-wd-atc-enhanced', '');
    nativeBannerSequence += 1;
    banner.__wdAtcSession = nativeBannerSequence;
    activeNativeBanner = banner;
    banner.setAttribute('role', 'dialog');
    banner.setAttribute('aria-modal', 'true');
    banner.setAttribute('aria-label', label('added', 'Added to your cart'));
    // The header has transforms/sticky positioning which can make 'fixed'
    // relative to the header, not the viewport. Move the SAME Empire element
    // into body before its animation and focus listeners are registered.
    if (banner.parentNode !== document.body) document.body.appendChild(banner);
    var close = banner.querySelector('[data-atc-banner-close]');
    var keep = banner.querySelector('[data-wd-atc-continue]');
    banner.querySelectorAll('[data-atc-banner-cart-button]').forEach(function (button) {
      button.textContent = baseViewCartLabel();
    });
    if (keep && close) {
      // The previous global .button-secondary styling made this text visually disappear.
      keep.textContent = label('continue', 'Continue shopping');
      keep.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        close.click();
      });
    }
    var cart = banner.querySelector('.atc-banner--cart');
    var recommendationCards = recommendations({ allowQuickAdd: true });
    if (recommendationCards && cart) {
      cart.insertBefore(recommendationCards, cart.firstChild);
    } else if (cart) {
      // Collection and featured cards render the subtotal in the cart column.
      // Move it into the product column before hiding the empty upsell column.
      // Empire's data-atc-banner-cart-subtotal selector still points to the same node.
      var subtotal = cart.querySelector('.atc-banner--cart-subtotal');
      var product = banner.querySelector('.atc-banner--product');
      var inner = banner.querySelector('.atc-banner--inner');
      var footer = cart.querySelector('.atc-banner--cart-footer');
      if (subtotal && product) product.appendChild(subtotal);
      if (footer && inner) inner.appendChild(footer);
    }
    // 2026 WilderdijkDynamics. 4.63: keep the original native cart actions
    // outside the recommendations column so all three actions remain accessible.
    var nativeFooter = banner.querySelector('.atc-banner--cart-footer');
    var nativeInner = banner.querySelector('.atc-banner--inner');
    if (nativeFooter && nativeInner && nativeFooter.parentNode !== nativeInner) nativeInner.appendChild(nativeFooter);
    if (close) {
      // Invalidate this banner before Empire starts its close animation. Any
      // delayed cart.js read from an upsell may still update the cart counter,
      // but it can no longer touch this flyout or a later flyout.
      close.addEventListener('click', function () {
        if (activeNativeBanner === banner) activeNativeBanner = null;
        banner.__wdAtcSession = null;
      });
      banner.addEventListener('click', function (event) {
        if (event.target === banner) close.click();
      });
    }
  }

  function dismiss() {
    if (!modal) return;
    var old = modal;
    modal = null;
    document.removeEventListener('keydown', onKeydown);
    old.remove();
    document.body.classList.remove('wd-atc-dialog-open');
    if (lastFocused && lastFocused.isConnected) lastFocused.focus();
  }

  function onKeydown(event) {
    if (event.key === 'Escape') { dismiss(); return; }
    if (!modal || event.key !== 'Tab') return;
    var nodes = Array.prototype.slice.call(modal.querySelectorAll('button:not([disabled]),a[href]'));
    if (!nodes.length) return;
    if (event.shiftKey && document.activeElement === nodes[0]) {
      event.preventDefault(); nodes[nodes.length - 1].focus();
    } else if (!event.shiftKey && document.activeElement === nodes[nodes.length - 1]) {
      event.preventDefault(); nodes[0].focus();
    }
  }

  function showDialog(cart, item) {
    dismiss();
    lastFocused = document.activeElement;
    var overlay = el('div', 'wd-atc-overlay');
    var panel = el('section', 'wd-atc-dialog');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', label('added', 'Added to your cart'));
    var close = el('button', 'wd-atc-dialog__close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', label('close', 'Close'));
    close.addEventListener('click', dismiss);
    panel.appendChild(close);

    var heading = el('h2', 'wd-atc-dialog__title');
    var check = el('span', 'wd-atc-dialog__check', '✓');
    check.setAttribute('aria-hidden', 'true');
    heading.appendChild(check);
    heading.appendChild(document.createTextNode(label('added', 'Added to your cart')));
    panel.appendChild(heading);

    var layout = el('div', 'wd-atc-dialog__layout');
    var left = el('div', 'wd-atc-dialog__left');
    var product = el('div', 'wd-atc-dialog__product');
    if (item) {
      if (item.image) {
        var image = el('img', 'wd-atc-dialog__image');
        image.src = typeof item.image === 'string' ? item.image : (item.image.src || '');
        image.alt = '';
        image.width = 155;
        image.height = 155;
        product.appendChild(image);
      }
      product.appendChild(el('div', 'wd-atc-dialog__product-name', item.product_title || item.title || ''));
      var variant = item.variant_title || (item.variant_options && item.variant_options.join(', ')) || '';
      if (variant && variant !== 'Default Title') product.appendChild(el('div', 'wd-atc-dialog__variant', variant));
      var itemPrice = item.final_price != null ? item.final_price : item.price;
      if (itemPrice != null) product.appendChild(el('div', 'wd-atc-dialog__price', money(itemPrice, cart && cart.currency)));
    }
    left.appendChild(product);
    if (cart && Number.isFinite(cart.total_price)) {
      var subtotal = el('div', 'wd-atc-dialog__subtotal');
      subtotal.appendChild(el('span', 'wd-atc-dialog__subtotal-label', label('subtotal', 'Cart subtotal')));
      subtotal.appendChild(el('span', 'wd-atc-dialog__subtotal-price', money(cart.total_price, cart.currency)));
      left.appendChild(subtotal);
    }
    layout.appendChild(left);
    var right = el('div', 'wd-atc-dialog__right');
    var recs = recommendations({ allowQuickAdd: true });
    if (recs) right.appendChild(recs);
    if (recs) {
      layout.appendChild(right);
    } else {
      layout.classList.add('wd-atc-dialog__layout--no-upsells');
    }
    panel.appendChild(layout);

    var actions = el('div', 'wd-atc-dialog__actions');
    var keep = el('button', 'wd-atc-dialog__secondary', label('continue', 'Continue shopping'));
    keep.type = 'button';
    keep.addEventListener('click', dismiss);
    actions.appendChild(keep);
    var view = el('a', 'wd-atc-dialog__primary', baseViewCartLabel());
    view.href = cartUrl;
    view.setAttribute('data-wd-modal-cart-count', '');
    actions.appendChild(view);
    var form = el('form', 'wd-atc-dialog__checkout-form');
    form.action = cartUrl;
    form.method = 'post';
    var checkout = el('button', 'wd-atc-dialog__checkout', label('checkout', 'Checkout'));
    checkout.type = 'submit';
    checkout.name = 'checkout';
    form.appendChild(checkout);
    actions.appendChild(form);
    panel.appendChild(actions);
    overlay.appendChild(panel);
    overlay.addEventListener('click', function (event) { if (event.target === overlay) dismiss(); });
    modal = overlay;
    document.body.appendChild(overlay);
    document.body.classList.add('wd-atc-dialog-open');
    document.addEventListener('keydown', onKeydown);
    close.focus();
  }

  function showSuccess(item) {
    if (busy) return Promise.resolve();
    busy = true;
    return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      }).then(function (cart) {
        // Count presentation only. Do not dispatch a new tracking, cart, or add-to-cart event.
        document.querySelectorAll('[data-header-cart-count]').forEach(function (counter) {
          counter.dataset.headerCartCount = cart.item_count;
          counter.classList.toggle('visible', cart.item_count > 0);
        });
        showDialog(cart, item);
      }).catch(function () { showDialog(null, item); })
      .finally(function () { busy = false; });
  }

  window.WDAtcExperience = { showSuccess: showSuccess };
  window.addEventListener('cartcount:update', enhanceNativeBanner);
}());
